














































import { Component, Prop, Vue } from 'vue-property-decorator';
import Api from '@/project/http/Api.service';

@Component
export default class NextDelivery extends Vue {
    @Prop({ required: true })
    itemIds!: string[];

    @Prop({ required: false, type: String })
    mode!: 'product' | 'basket';

    visible: boolean = false;
    hours: string = '';
    minutes: string = '';
    seconds: string = '';

    totalSeconds: number = 0;

    async mounted() {
        const result = await Api.nextDelivery.getNextDelivery(this.itemIds);
        if (result.secondsUntilNextDelivery) {
            this.visible = true;

            this.totalSeconds = result.secondsUntilNextDelivery;

            setInterval(() => {
                this.totalSeconds--;
                this.updateCountDown();
            }, 1000);

            this.updateCountDown();
        }
    }

    updateCountDown() {
        const numHours = Math.floor(this.totalSeconds / 60 / 60);
        const numMinutes = Math.floor((this.totalSeconds / 60) - (numHours * 60));
        const numSeconds = Math.floor((this.totalSeconds) - (numHours * 60 * 60) - (numMinutes * 60));

        this.hours = numHours.toString().padStart(2, '0');
        this.minutes = numMinutes.toString().padStart(2, '0');
        this.seconds = numSeconds.toString().padStart(2, '0');
    }
}
